<template>
    <template v-if="isInitialize && !isWait && !isError">
        <ClassicLayout v-if="validTheme(Enums.THEME.CLASSIC)" :leftSidebar="page.leftSidebar">
            <router-view :key="$route.fullPath" v-if="!isWaitSub" />
        </ClassicLayout>
        <EmptyLayout v-else>
            <router-view :key="$route.fullPath" v-if="!isWaitSub"/>
        </EmptyLayout>
    </template>
    <template v-else-if="isError">
        <div class="layout-theme empty">
            <ErrorView page="App" :msg="error"></ErrorView>
        </div>
    </template>
    <template v-else>
        <PageLoader :isPage="true" :isLoaded="false" />
    </template>
</template>
<script>
    import { reactive, toRefs, computed, watch, nextTick, onBeforeUnmount } from "vue";
    
    import { useRoute, useRouter } from "vue-router";
    import { useStore } from "vuex";
    
    import { Constants } from "@/helpers/constants";
    import { Enums } from "@/helpers/enums";
    import { Links } from "@/helpers/links";
    import { appData, C, D, J, Rnd } from "@/helpers/global";
    import { Ajax, MethodType, Msg, Popup, Wait, Web } from "@/helpers/web";
    import TooltipManager from '@/helpers/tooltip.js';

    import EmptyLayout from "@/layouts/EmptyLayout.vue";
    import ClassicLayout from "@/layouts/ClassicLayout.vue";
     
    import ErrorView from "@/views/ErrorView.vue";
    import PageLoader from "@/components/PageLoader.vue";

    import { SettingService } from "@/services/api/setting";
    import { UserService } from "@/services/api/user";
    import { NotificationService } from "@/services/api/notification";
    import { MessageService } from "@/services/api/message";
    import { DataListenerService } from "@/services/api/data-listener";

    import { StoreUser, StoreContract } from "@/store/constants";

    export default {
        name: "App",
        components: {
            EmptyLayout,
            ClassicLayout,
            ErrorView,
            PageLoader,
        },
        setup() {
            const version = "1.83.263";
            if (process.env.NODE_ENV === "production") {
                appData.base = "https://app.rehberimsensin.com/";
                appData.serverBase = "https://api.rehberimsensin.com/";
                appData.mediaBase = "https://doc.rehberimsensin.com/";
                appData.meetBase = "https://meet.rehberimsensin.com/";
            }
            else if (process.env.NODE_ENV === "staging") {
                appData.base = "https://dev.app.rehberimsensin.com/";
                appData.serverBase = "https://dev.api.rehberimsensin.com/";
                appData.mediaBase = "https://dev.doc.rehberimsensin.com/";
                appData.meetBase = "https://meet.rehberimsensin.com/";
            }
            else { //Local
                const frontEnd = false; // TODO: Front-End ise bu alanı true yap

                appData.base = window.location.origin + "/";
                if (frontEnd) { // Front-end verileri localden almaz!
                    appData.serverBase = "https://dev.api.rehberimsensin.com/";
                    //appData.mediaBase = "https://dev.doc.rehberimsensin.com/";
                    appData.mediaBase = "https://dev.api.rehberimsensin.com/doc/";
                    appData.meetBase = "https://meet.rehberimsensin.com/";
                }
                else {
                    appData.serverBase = "https://localhost:52002/";
                    //appData.mediaBase = "https://localhost:52008/"; // Medya Sunucu için
                    appData.mediaBase = "https://localhost:52002/doc/";
                    appData.meetBase = "https://localhost:52010/";
                }
            }

            const router = useRouter();
            const route = useRoute();
            const store = useStore();

            const loginData = {
                promise: null,
                pendingVersion: 0,
                ready: false,
                version: 0
            };

            const e = reactive({
                isInitialize: false,
                isWait: true,
                isWaitSub: true,
                error: null,
                page: {
                    css: {},
                    theme: Enums.THEME.NULL,
                    leftSidebar: Enums.MENU_TYPE.MAIN,
                    header: {},
                },
                bus: appData.eventBus([Constants.Key.SnapData]),
                isError: computed(() => {
                    return C.Str(e.error) != "";
                }),
                validVersion() {
                    if (version != C.Str(appData.fn.getLocal("version"))) {
                        localStorage.clear();
                        sessionStorage.clear();

                        store.replaceState({});

                        appData.fn.setLocal("version", version);
                        Web.Refresh();
                        return false;
                    }
                    return true;
                },
                validTheme(theme) {
                    return e.page.theme == theme;
                },
                getInitData: async () => {
                    await SettingService.InitAsync().then(async (data) => {
                        appData.initialize(data);
                        e.page.theme = C.Int(route.meta.theme);
                        e.page.leftSidebar = C.Int(route.meta.leftSidebar);
                        e.isInitialize = true;
                        appData.isApp = C.Bool(appData.cookie.get("isApp"));
                        appData.isMobile = appData.isApp || Web.IsMobileTablet();
                        await e.loadCss();
                        await e.loginDetect();
                    }).catch((error) => {
                        e.error = error;
                    });

                    appData.bus.on(e.bus, (event) => {
                        if (event.key == Constants.Key.SnapData) {
                            const model = C.Str(event.value.model);
                            switch (model) {
                                case Constants.DataModel.Users:
                                case Constants.DataModel.UserPackages:
                                    e.isInitialize = false;
                                    e.isWait = true;
                                    store.dispatch(StoreUser.load, {
                                        wait: () => { e.isWait = false; },
                                        reset: true,
                                        callback: (data) => {
                                            e.isInitialize = true;
                                        }
                                    });
                                    break;
                            }
                        }
                    });
                },
                loginDetect: async () => {
                    if (e.isInitialize) {
                        e.page.theme = C.Int(route.meta.theme);
                        if (!e.validTheme(Enums.THEME.NULL)) {
                            if (!e.validTheme(Enums.THEME.EMPTY)) {
                                await UserService.GetTokenIsLogin(async () => {
                                    if (C.Bool(store.getters[StoreUser.get].phoneNumberConfirmed)) {
                                        setTimeout(() => {
                                            document.getElementById('modals').style.display = null;
                                            setTimeout(() => {
                                                e.isWait = false;
                                                nextTick(() => {
                                                    e.isWaitSub = false;
                                                });
                                            }, 50);
                                        }, 50);
                                         await e.getLoginData();
                                    }
                                    else {
                                        UserService.VerifyPhoneNumberRedirect();
                                    }                                   
                                });
                            }
                            else {
                                setTimeout(() => {
                                    document.getElementById('modals').style.display = null;
                                    setTimeout(() => {
                                        e.isWait = false;
                                        nextTick(() => {
                                            e.isWaitSub = false;
                                        });
                                    }, 50);
                                }, 50);
                                
                            }
                        }
                    }
                },
                getLoginData: async () => {
                    const version = loginData.version;
                    if (loginData.ready) {
                        return;
                    }
                    if (loginData.promise) {
                        const pendingVersion = loginData.pendingVersion;
                        await loginData.promise;
                        if (version === pendingVersion || version !== loginData.version || loginData.ready) {
                            return;
                        }
                    }
                    if (loginData.promise) {
                        return loginData.promise;
                    }

                    loginData.pendingVersion = version;

                    const task = Promise.resolve().then(async () =>
                    {
                        if (version !== loginData.version) {
                            return;
                        }
                        await DataListenerService.ListenServer();

                        if (version !== loginData.version) {
                            return;
                        }
                        await NotificationService.ListenServer();
                        if (version !== loginData.version) {
                            return;
                        }
                        const connected = await MessageService.ListenServer();
                        if (version === loginData.version && connected) {
                            loginData.ready = true;
                        }
                    });
                    loginData.promise = task;

                    try {
                        await task;
                    }
                    finally {
                        if (loginData.promise === task) {
                            loginData.promise = null;
                        }
                    }
                },
                validContract() {
                    if (e.validTheme(Enums.THEME.CLASSIC) && !route.fullPath.includes('/user/profile') && !route.fullPath.includes('/user/message')) {
                        e.list.contractRequired.load(() => {
                            e.list.contractRequired.detect();
                        });
                    }
                }, 
                resetLoginData: async () => {
                    loginData.version += 1;
                    loginData.ready = false;
                    const results = await Promise.allSettled([
                        Promise.resolve().then(() => MessageService.StopListenServer()),
                        Promise.resolve().then(() => NotificationService.StopListenServer()),
                        Promise.resolve().then(() => DataListenerService.StopListenServer())
                    ]);
                    for (const result of results) {
                        if (result.status === "rejected") {
                            console.warn("Listener stop error:", result.reason);
                        }
                    }
                },
                scrollTop() {
                    //try {
                    //    const psInstance = appData.fn.main();
                    //    if(psInstance) {
                    //        psInstance.scrollTop = 0;
                    //        psInstance.classList.remove("ps--active-y");
                    //    }
                    //} catch (error) {}
                },
                loadCss: async () => {
                    if (!appData.isMobile) {
                        await import("@/assets/scss/app.scss");
                        //appData.fn.body().style.minWidth = "991px";
                        window.resizedFinished = null;
                        window.addEventListener('resize', () => {
                            if (window.resizedFinished) { clearTimeout(window.resizedFinished); }
                            window.resizedFinished = setTimeout(appData.fn.setViewport(991), 250);
                        });
                        e.initToolTips();
                        appData.fn.setViewport(991);
                        
                    }
                    else {
                        await import("@/assets/scss.mobile/app.scss");
                        //e.initToolTips();
                        e.userSelectNone();
                    }
                    document.addEventListener("dragstart", (event) => {
                        event.preventDefault();
                    });
                },
                tooltipManager: null,
                initToolTips() {
                    e.tooltipManager = new TooltipManager();
                    e.tooltipManager.init();
                    //new Tooltip(document.body, {
                    //    selector: "[data-bs-toggle='tooltip']",
                    //});
                },
                userSelectNone() {
                    const elements = document.querySelectorAll('[class^="badge-"], .btn, .calendar, .mood img, .fixed-value, .modal');
                    elements.forEach((el) => {
                        el.addEventListener('selectstart', (event) => {
                            event.preventDefault();
                        });
                        el.addEventListener('touchstart', (event) => {
                            event.preventDefault();
                        });
                    });
                },

                isLiveEducation: computed(() => route.path.startsWith("/live-education/")),
                list: {
                    contractRequired: {
                        load(callback) {
                            Web.Area((wait) => {
                                store.dispatch(StoreContract.loadListRequired, { wait, callback });
                            }, appData.fn.main());
                        },
                        detect() {
                            if (e.list.contractRequired.count.general > 0) {
                                Popup.Info("Lütfen önce onay bekleyen sözleşmelerinizi onaylayınız!", "Bekleyen Sözleşmeler", null, -4000, () => {
                                   Web.Redirect(Links.Url(Links.User.Contract));
                                });
                                return false;
                            }

                            if (e.list.contractRequired.count.liveEducation > 0 && e.isLiveEducation) {
                                Popup.Info("Lütfen önce özel ders sözleşmenizi onaylayınız!", "Özel Ders Sözleşmesi", null, -3000, () => {
                                    Web.Redirect(Links.Url(Links.User.Contract));
                                });
                                return false;
                            }
                            return true;
                        },
                        count: computed(() => {
                            const l = store.state.contract.listRequired;
                            if (l) {
                                let liveEducation = 0;
                                for (let i = 0; i < l.length; i++) {
                                    if (l[i].name?.includes("Özel Ders")) {
                                        liveEducation++;
                                    }
                                }
                                return { general: l.length - liveEducation, liveEducation };
                            }
                            return { general: 0, liveEducation: 0 };
                        }),
                    },
                }
            });
            onBeforeUnmount(()=> {
                if (e.tooltipManager) {
                    e.tooltipManager.dispose();
                }
            });

            UserService.SetLogoutHandler(() => e.resetLoginData());

            watch(route, async (n, o) =>
            {
                e.validContract();
                if (e.isInitialize) {
                    appData.page = {}; // temp data kullanimi
                    try {
                        e.isWaitSub = true;
                        e.isWait = true;
                        e.page.theme = C.Int(route.meta.theme);
                        e.page.leftSidebar = C.Int(route.meta.leftSidebar);
                        appData.eventBus(Constants.Key.RightSidebar).set(Constants.Key.RightSidebar, { type: 0 });
                        await e.loginDetect();                        
                    } catch (ex) {
                        e.error = ex.message;
                    }
                    e.scrollTop();
                }
            },
            {
                deep: true,
                immediate: true,
            });
            return { ...toRefs(e) };
        },
        async mounted() {
            try {
                if (this.validVersion()) {
                    await this.getInitData();
                    this.validContract();
                }
            } catch (ex) {
                this.error = ex.message;
            }
        },
    }
</script>
